<div class="nfse-page">
    <div class="nfse-toolbar">
        <button pButton type="button" icon="pi pi-print"
                [label]="'user.account.subscriptionTab.invoices.nfDocPrint' | transloco"
                [disabled]="!dps"
                (click)="print()"></button>
        <button pButton type="button" icon="pi pi-download" 
                [label]="'user.account.subscriptionTab.invoices.downloadNfXml' | transloco"
                [disabled]="loading || error === 'notAvailable' || error === 'loadError'"
                (click)="downloadXml()"></button>
    </div>

    <div *ngIf="loading" class="nfse-status">
        <p-progressSpinner styleClass="small-spinner"></p-progressSpinner>
    </div>

    <p *ngIf="error === 'notAvailable'" class="nfse-status">{{ 'user.account.subscriptionTab.invoices.nfNotAvailable' | transloco }}</p>
    <p *ngIf="error === 'loadError'" class="nfse-status">{{ 'user.account.subscriptionTab.invoices.nfDocLoadError' | transloco }}</p>
    <p *ngIf="error === 'invalid'" class="nfse-status">{{ 'user.account.subscriptionTab.invoices.nfDocInvalid' | transloco }}</p>

    <article *ngIf="dps" class="nfse-doc" lang="pt-BR">
        <header class="nfse-header">
            <div>
                <h1>Representação da DPS</h1>
                <p>Declaração de Prestação de Serviço · NFS-e padrão nacional</p>
            </div>
            <span *ngIf="dps.homologacao" class="nfse-badge">HOMOLOGAÇÃO</span>
        </header>

        <div class="nfse-warning">
            Documento sem valor fiscal. A NFS-e oficial pode ser consultada no Portal Nacional da NFS-e.
        </div>

        <section>
            <h2>Identificação</h2>
            <dl class="nfse-grid">
                <div><dt>Série / Nº da DPS</dt><dd>{{ dps.serie }} / {{ dps.numero }}</dd></div>
                <div><dt>Emissão</dt><dd>{{ dataHora(dps.emissao) }}</dd></div>
                <div><dt>Competência</dt><dd>{{ data(dps.competencia) }}</dd></div>
                <div><dt>Local de emissão</dt><dd>{{ municipio(dps.codigoMunicipioEmissao) }}</dd></div>
                <div class="nfse-wide"><dt>Identificador</dt><dd class="nfse-mono">{{ dps.id }}</dd></div>
            </dl>
        </section>

        <section *ngIf="dps.prestador as prestador">
            <h2>Prestador do serviço</h2>
            <dl class="nfse-grid">
                <div class="nfse-wide"><dt>Nome</dt><dd>{{ nomePrestador(prestador) || '—' }}</dd></div>
                <div><dt>{{ prestador.tipoDocumento || 'Documento' }}</dt><dd>{{ documento(prestador.documento) }}</dd></div>
                <div *ngIf="prestador.fone"><dt>Telefone</dt><dd>{{ fone(prestador.fone) }}</dd></div>
                <div *ngIf="prestador.email"><dt>E-mail</dt><dd>{{ prestador.email }}</dd></div>
                <div *ngIf="enderecoPrestador(prestador) as end" class="nfse-wide"><dt>Endereço</dt><dd>{{ end }}</dd></div>
                <div><dt>Simples Nacional</dt><dd>{{ simplesNacional(dps.regimeTributario.simplesNacional) }}</dd></div>
                <div><dt>Regime especial</dt><dd>{{ regimeEspecial(dps.regimeTributario.regimeEspecial) }}</dd></div>
            </dl>
        </section>

        <section *ngIf="dps.tomador as tomador">
            <h2>Tomador do serviço</h2>
            <dl class="nfse-grid">
                <div class="nfse-wide"><dt>Nome</dt><dd>{{ tomador.nome || '—' }}</dd></div>
                <div><dt>{{ tomador.tipoDocumento || 'Documento' }}</dt><dd>{{ documento(tomador.documento) }}</dd></div>
                <div *ngIf="tomador.fone"><dt>Telefone</dt><dd>{{ fone(tomador.fone) }}</dd></div>
                <div *ngIf="tomador.email"><dt>E-mail</dt><dd>{{ tomador.email }}</dd></div>
                <div *ngIf="endereco(tomador) as end" class="nfse-wide"><dt>Endereço</dt><dd>{{ end }}</dd></div>
            </dl>
        </section>

        <section>
            <h2>Serviço</h2>
            <dl class="nfse-grid">
                <div class="nfse-wide"><dt>Descrição</dt><dd>{{ dps.servico.descricao }}</dd></div>
                <div><dt>Código de tributação nacional</dt><dd>{{ codigoTributacao(dps.servico.codigoTributacaoNacional) }}</dd></div>
                <div *ngIf="dps.servico.codigoNbs"><dt>NBS</dt><dd>{{ codigoNbs(dps.servico.codigoNbs) }}</dd></div>
                <div><dt>Local da prestação</dt><dd>{{ municipio(dps.servico.codigoMunicipioPrestacao) }}</dd></div>
            </dl>
        </section>

        <section>
            <h2>Valores e tributos</h2>
            <div class="nfse-total">
                <span>Valor do serviço</span>
                <strong>{{ moeda(dps.valores.valorServico) }}</strong>
            </div>
            <dl class="nfse-grid">
                <div><dt>ISSQN · tributação</dt><dd>{{ tributacaoIssqn(dps.valores.issqn.tributacao) }}</dd></div>
                <div><dt>ISSQN · retenção</dt><dd>{{ retencaoIssqn(dps.valores.issqn.retencao) }}</dd></div>
            </dl>
            <ng-container *ngIf="dps.valores.pisCofins as pc">
                <h3>PIS / COFINS</h3>
                <dl class="nfse-grid">
                    <div><dt>CST</dt><dd>{{ pc.cst }}</dd></div>
                    <div><dt>Base de cálculo</dt><dd>{{ moeda(pc.baseCalculo) }}</dd></div>
                    <div><dt>Retenção</dt><dd>{{ retencaoPisCofins(pc.retencao) }}</dd></div>
                    <div><dt>PIS ({{ percentual(pc.aliquotaPis) }})</dt><dd>{{ moeda(pc.valorPis) }}</dd></div>
                    <div><dt>COFINS ({{ percentual(pc.aliquotaCofins) }})</dt><dd>{{ moeda(pc.valorCofins) }}</dd></div>
                </dl>
            </ng-container>
            <ng-container *ngIf="dps.valores.totalTributos as tt">
                <h3>Total aproximado dos tributos</h3>
                <dl class="nfse-grid">
                    <div><dt>Federais</dt><dd>{{ moeda(tt.federal) }}</dd></div>
                    <div><dt>Estaduais</dt><dd>{{ moeda(tt.estadual) }}</dd></div>
                    <div><dt>Municipais</dt><dd>{{ moeda(tt.municipal) }}</dd></div>
                </dl>
            </ng-container>
            <ng-container *ngIf="dps.ibsCbs as ibs">
                <h3>IBS / CBS</h3>
                <dl class="nfse-grid">
                    <div><dt>CST</dt><dd>{{ ibs.cst }}</dd></div>
                    <div><dt>Classificação tributária</dt><dd>{{ ibs.classificacao }}</dd></div>
                </dl>
            </ng-container>
        </section>
    </article>
</div>
